import events from './modules/events'
import comments from './modules/comments'
import questions from './modules/questions'
import cabinet from './modules/cabinet'
import order from './modules/order'
import landingSubscribe from './modules/landingSubscribe'
import landingRepair from '@/api/modules/landingRepair'
import blocks from './modules/blocks'
import serials from './modules/serials'
import auth from './modules/auth'
import report from '@/api/modules/report'

export default {
  events,
  comments,
  questions,
  cabinet,
  order,
  landingSubscribe,
  landingRepair,
  blocks,
  serials,
  auth,
  report
}
